// extracted by mini-css-extract-plugin
module.exports = {"root":"BundleLookStickyHeader_root__2rpt-","spinAround":"BundleLookStickyHeader_spinAround__3On7Q"};